// Phase 1 hardcoded sample. Replace audio_url with real mp3 URLs (e.g. ElevenLabs
// output uploaded to the CDN) and tune duration_ms to match. If audio_url is
// omitted or empty, the slide uses fallback_duration_ms as a silent timer.

export default {
  title: 'Working with AI — a first tour',
  video_config: {
    style_preset: 'dark',
    brand_name: 'LearningFirst',
    color_scheme: {
      background: '#0B1220',
      text: '#F8FAFC',
      accent: '#60A5FA',
      highlight: '#F59E0B'
    },
    font: {
      heading: 'Inter, system-ui, sans-serif',
      body: 'Inter, system-ui, sans-serif'
    },
    transition: 'fade',
    transition_duration_ms: 400,
    pause_between_slides_ms: 300
  },
  slides: [
    {
      id: 1,
      type: 'title',
      narration: 'Welcome. Today we take a first, honest look at working with AI — what it actually is, and how to get useful work out of it.',
      audio_url: '',
      duration_ms: 7000,
      fallback_duration_ms: 7000,
      visual: {
        template: 'title-card',
        heading: 'Working with AI',
        subheading: 'A first, honest tour',
        byline: 'LearningFirst Collection'
      }
    },
    {
      id: 2,
      type: 'content',
      narration: 'The first thing to understand is that AI is not magic. It is a pattern-completion engine trained on a vast amount of text.',
      audio_url: '',
      duration_ms: 7500,
      fallback_duration_ms: 7500,
      visual: {
        template: 'text-center',
        eyebrow: 'Lesson 1',
        heading: 'AI is a pattern-completion engine',
        body: 'Not a thinking machine — a very good guess-the-next-token machine.',
        emphasis: ['pattern-completion']
      }
    },
    {
      id: 3,
      type: 'content',
      narration: 'Which means three things matter most when you prompt it: the context you provide, the examples you give, and the clarity of the task.',
      audio_url: '',
      duration_ms: 9000,
      fallback_duration_ms: 9000,
      visual: {
        template: 'bullet-list',
        heading: 'What actually moves the needle',
        bullets: [
          'Context — what the model knows before it answers',
          'Examples — concrete instances of the shape you want',
          'Clarity — one task, precisely defined'
        ]
      }
    },
    {
      id: 4,
      type: 'outro',
      narration: 'That is the first step. Keep going — the full collection unpacks each of these with real examples.',
      audio_url: '',
      duration_ms: 7000,
      fallback_duration_ms: 7000,
      visual: {
        template: 'outro',
        heading: 'Keep going.',
        body: 'Each of these gets a full lesson in the collection.',
        cta: 'Explore the full journey on LearningFirst'
      }
    }
  ]
}
